// extracted by mini-css-extract-plugin
export var closeButton = "_gj-2";
export var closeButtonIcon = "_gj-3";
export var lightboxContent = "_gj-1";
export var lightboxOverlay = "_gj-0";